import { z } from "zod";
import { DEVICE_TOKEN_MAX_LENGTH } from "./device-tokens.js";

/**
 * Shared DTO cho `POST /v1/auth/logout` (US-E24.F5-0354-S02 · @UC9577).
 *
 * 🔴 VÌ SAO CÓ BODY: logout cũ chỉ `revokeAllForUser` — lane auth **0 lần** nhắc `device_tokens`, còn
 * worker chọn token thuần theo `userId` (`device-token-push-provider.ts`). Hệ quả: người dùng bán/cho
 * máy cũ, đăng xuất trên máy mới ⇒ mất phiên ở CẢ HAI máy, nhưng CẢ HAI vẫn còn `device_tokens` ⇒
 * worker vẫn bắn *"Bạn còn 500.000đ chưa đóng quỹ lớp 3A"* **vào máy đã sang tay người khác**. Đó là
 * rò thông tin tài chính qua kênh không đi qua bất kỳ guard nào.
 *
 * QĐ PO 06/08 (c) — phương án A: `deviceToken` **TUỲ CHỌN**.
 *  - Có ⇒ server xoá token đó trong CÙNG transaction với revoke phiên (một cú bấm cắt đủ hai đường).
 *  - Không có ⇒ hành vi y hệt bản cũ ⇒ **client cũ 0 regress**.
 * Loại phương án B (bắt client gọi `DELETE /v1/me/device-tokens` trước) vì nó phụ thuộc *"client nhớ
 * gọi đúng thứ tự"* — không cưỡng chế được với app bị kill giữa chừng / mất mạng / bản cũ.
 *
 * BẢO MẬT:
 *  - `.strict()` chặn field lạ (C5). KHÔNG nhận `userId` từ body — self-only, userId lấy từ JWT.
 *  - Raw device token là PII: KHÔNG log (`logger.config.ts` redact `req.body.deviceToken`), KHÔNG
 *    echo lại trong response (logout trả 204 rỗng), KHÔNG đưa vào audit diff.
 *  - `DELETE /v1/me/device-tokens` vẫn giữ nguyên — đây KHÔNG phải cơ chế xoá thứ hai: cả hai cùng
 *    gọi `DeviceTokensService.remove` (§3.8 "reuse, không cơ chế thứ hai").
 */
export const logoutRequestSchema = z
  .object({
    /** Device token của CHÍNH máy đang đăng xuất. Vắng ⇒ chỉ revoke phiên (hành vi cũ). */
    deviceToken: z.string().min(1).max(DEVICE_TOKEN_MAX_LENGTH).optional(),
  })
  .strict();

export type LogoutRequest = z.infer<typeof logoutRequestSchema>;
